import { styled, Typography } from "@mui/material";

export const AssessPanelSubheading = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.size.normal};
`;
